import { OlTeflPrice } from '../../../lib/types/models/ol/tefl-price/ol-tefl-price'
import { OlTeflPriceInput } from '../../../lib/types/models/ol/tefl-price/ol-tefl-price-input'
import { IdInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createOlTeflPrice = async (data: IdInput<OlTeflPriceInput>) => {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.ols.createOlTeflPrice.url, { olId: id }))
    .post<OlTeflPrice, OlTeflPriceInput>(rest)
}
